module.exports = __webpack_public_path__ + "img/leftCircle.ac071593.png";